export const numbers = [
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
  "eleven",
  "twelve",
  "thirteen",
  "fourteen",
  "fifteen",
  "sixteen",
  "seventeen",
  "eighteen"
];

export function nameFromNumber(number: number): string {
  return numbers[number];
}

export function numberFromName(name: string): number {
  if (!name) {
    console.warn("Given number string is undefined, null, or empty, returning null.", name);
    return null;
  }
  try {
    const lowercaseName = name.toLocaleLowerCase();
    const index = numbers.indexOf(lowercaseName);
    if (index >= 0) {
      return index;
    }
  } catch (e) {
    console.warn("not a string, returning null", name, e);
  }
  return null;
}
